import firebase from 'firebase';
import { db, storage } from './firebase';
import { FIRESTORE_KEYS } from '../utils/constants';

export default function useSchoolService() {
  const getSchool = (id) =>
    db
      .collection(FIRESTORE_KEYS.SCHOOLS)
      .doc(id)
      .get()
      .then((res) => res.data());

  const createSchool = () =>
    db.collection(FIRESTORE_KEYS.SCHOOLS).add({
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  const updateSchool = (schoolId, data) => db.collection(FIRESTORE_KEYS.SCHOOLS).doc(schoolId).update(data);

  const deleteSchool = (id) => db.collection(FIRESTORE_KEYS.SCHOOLS).doc(id).delete();

  const addSchoolImage = (docId, image) => {
    const ref = storage.ref(`${FIRESTORE_KEYS.SCHOOLS}/${docId}/${image.name}`);
    return ref.put(image).then(() => ref.getDownloadURL());
  };

  return { getSchool, createSchool, updateSchool, deleteSchool, addSchoolImage };
}
